import React, { useState } from 'react';
import { View, Image, StyleSheet, TouchableOpacity } from 'react-native';
import PopUp from '../popUp';
import CustomText from '../customText/CustomText';
import theme from '../../constants/theme.style.js';
import { baseUrl } from '../../constants/baseUrl';
import ProfileAvatarBackground from '../profileAvatar/ProfileAvatarBackground';

const acceptRequestIcon = require('../../assets/icons/friends/accept.png');
const declineRequestIcon = require('../../assets/icons/friends/decline.png');

const styles = StyleSheet.create({
  contact: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: 12,
    paddingBottom: 12,
    borderBottomWidth: 1,
    borderColor: theme.GREY_MEDIUM_COLOR,
  },
  contactImageContainer: {
    width: 65,
    height: 65,
    borderRadius: 15,
    marginRight: 10,
    justifyContent: 'center',
    alignItems: 'center',
  },
  contactImage: {
    height: 65,
    width: 65,
    borderRadius: 15,
    overflow: 'hidden',
  },
  contactName: {
    color: theme.GREY_MEDIUM_COLOR,
    fontSize: theme.FONT_SIZE_HEADLINE,
    fontWeight: theme.FONT_WEIGHT_BOLD,
  },
  userName: {
    color: theme.GREY_MEDIUM_LIGHT_COLOR,
    fontSize: theme.FONT_SIZE_REGULAR,
  },
  requestIcon: {
    width: 20,
    height: 20,
  },
  requestIconContainer: {
    flex: 1,
    flexDirection: 'row',
    position: 'absolute',
    right: 0,
  },
  requestButton: {
    height: 40,
    width: 40,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: theme.BUTTON_BIG_BORDER_RADIUS,
  },
  acceptRequestButton: {
    backgroundColor: '#56C59620',
  },
  declineRequestButton: {
    backgroundColor: '#D0000015',
    marginLeft: 20,
  },
});

export default function FriendRequestItem({
  onAnswerFriendRequest,
  request,
  callbackAnswerSent,
  onFetch,
}) {
  const [friendRequestAnswered, setFriendRequestAnswered] = useState(['']);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalDescription, setModalDescription] = useState('');
  const [modalButtonText, setModalButtonText] = useState('');
  const [modalButtonColor, setModalButtonColor] = useState('');
  const [modalButtonBgColor, setModalButtonBgColor] = useState('');

  const answerFriendRequest = (answer) => {
    if (answer) {
      setModalDescription(`Accept friend request from\n${request.firstname} @${request.nickname}?`);
      setModalButtonText('Accept');
      setModalButtonColor('#56C596');
      setModalButtonBgColor('#56C59620');
    } else {
      setModalDescription(
        `Decline friend request from\n${request.firstname} @${request.nickname}?`,
      );
      setModalButtonText('Decline');
      setModalButtonColor('#A90000');
      setModalButtonBgColor('#D0000015');
    }
    setModalVisible(true);
  };

  async function deleteFriendRequest() {
    await onFetch({
      url: `${baseUrl}friendship/${request.requester}/${request.addressee}`,
      method: 'DELETE',
    }).catch(() => {
      // do nothing
    });
  }

  const handleFriendRequest = (action) => {
    if (action === 'Accept') {
      onAnswerFriendRequest(request, 2);
    } else {
      deleteFriendRequest();
    }
    setFriendRequestAnswered(friendRequestAnswered + request.nickname);
    callbackAnswerSent(action);
  };

  function callbackModalAccept() {
    handleFriendRequest(modalButtonText);
    setModalVisible(false);
  }

  function callbackModalNotNow() {
    setModalVisible(false);
  }

  if (!friendRequestAnswered.includes(request.nickname)) {
    return (
      <View style={styles.contact} testID={`${request.id}Contact`}>
        <View style={styles.contactImageContainer}>
          <ProfileAvatarBackground
            testID={`${request.id}ContactImage`}
            style={styles.contactImage}
            avatar={request.avatar}
          />
        </View>
        <View>
          <CustomText style={styles.contactName}>{request.firstname}</CustomText>
          <CustomText style={[styles.contactName, styles.userName]}>@{request.nickname}</CustomText>
        </View>
        <View style={styles.requestIconContainer}>
          <TouchableOpacity
            onPress={() => answerFriendRequest(true)}
            style={[styles.requestButton, styles.acceptRequestButton]}
            testID="friendRequest-yes"
          >
            <Image style={styles.requestIcon} source={acceptRequestIcon} />
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => answerFriendRequest(false)}
            style={[styles.requestButton, styles.declineRequestButton]}
            testID="friendRequest-no"
          >
            <Image style={styles.requestIcon} source={declineRequestIcon} />
          </TouchableOpacity>
        </View>
        {modalVisible && (
          <PopUp
            description={modalDescription}
            button1={modalButtonText}
            callback1={callbackModalAccept}
            button2="Not now"
            callback2={callbackModalNotNow}
            visability={modalVisible}
            leftColor={modalButtonColor}
            leftBgColor={modalButtonBgColor}
            rightColor="#828282"
            rightBgColor="#F2F2F2"
          />
        )}
      </View>
    );
  }
  return null;
}
